import React from 'react';
import { GridCellParams } from '@material-ui/data-grid';
import { Checkbox } from '@material-ui/core';
import { Field, FieldProps } from 'formik';

const CustomActivationCheckbox = (
  params: GridCellParams,
  serviceId: string,
  isViewOnly = false,
): JSX.Element => (
  <Field
    name={`selectedServiceCategories.${serviceId}.${params.row.id}.activation`}
  >
    {({ field, form }: FieldProps) => (
      <Checkbox
        checked={field.value}
        disabled={isViewOnly}
        onClick={() => {
          const nextChecked = !field.value;
          const currentRowPriority =
            form.values.selectedServiceCategories[serviceId][params.row.id]
              .priority;

          form.setFieldValue(
            `selectedServiceCategories.${serviceId}.${params.row.id}.activation`,
            nextChecked,
          );
          form.setFieldValue(
            `selectedServiceCategories.${serviceId}.${params.row.id}.priority`,
            '',
          );

          if (!nextChecked) {
            const serviceCategories =
              form.values.selectedServiceCategories[serviceId];
            const serviceCategoriesKeys = Object.keys(serviceCategories);

            serviceCategoriesKeys.forEach((k) => {
              const { priority, activation } = serviceCategories[k];
              if (activation && currentRowPriority < priority) {
                form.setFieldValue(
                  `selectedServiceCategories.${serviceId}.${k}.priority`,
                  priority - 1,
                );
              }
            });
          }
          if (document.activeElement instanceof HTMLElement) {
            document.activeElement.blur();
          }
        }}
        {...field}
      />
    )}
  </Field>
);

export default CustomActivationCheckbox;
